import { de_UpdateOrderDataCommand, se_UpdateOrderDataCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class UpdateOrderDataCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Api", "UpdateOrderData", {})
    .n("ApiClient", "UpdateOrderDataCommand")
    .f(void 0, void 0)
    .ser(se_UpdateOrderDataCommand)
    .de(de_UpdateOrderDataCommand)
    .build() {
}
